import { Platform } from "react-native";

export const appColors = {
  // Brand
  primary: "#05366b",
  primaryLight: "#8fb4dd",
  primaryMuted: "#adc6e0",
  primaryTint: "#e8f0f8",
  primaryTintDark: "#d0e2f0",

  // Backgrounds
  pageBg: "#eef1f5",
  cardBg: "#ffffff",
  inputBg: "#f0f4f8",
  statBg: "#f0f4f8",
  rowAlt: "#f8fafb",

  // Text
  textPrimary: "#0d1b2a",
  textSecondary: "#5f7080",
  textMuted: "#8fa3b4",

  // Borders
  border: "#dde4ec",
  borderLight: "#eef1f5",

  // Accent
  accent: "#1d9e75",
  accentLight: "#e2f5ee",

  // Semantic
  danger: "#c0392b",
  dangerLight: "#fff0ef",
  dangerBorder: "#f3c9c4",

  // Error
  backgroundError: "#ffe8e8",
  error: "#e53935",

  // Chart palette (navy → steel → slate → teal)
  chartPrincipal: "#05366b",
  chartInterest: "#8fb4dd",
  chartFees: "#c2ccd6",
  chartBalance: "#1d9e75",
  chartBalloon: "#6a4fbf",
};

/**
 * Cross-platform shadow helper.
 * On web: returns boxShadow only (avoids shadow* deprecation warning).
 * On native: returns shadow* props (iOS) + elevation (Android).
 *
 * Usage: ...cardShadow()  or  ...cardShadow("large")
 */
export const cardShadow = (size = "small") => {
  if (Platform.OS === "web") {
    return {
      boxShadow: size === "large" ? "0 8px 24px rgba(0,0,0,0.14)" : "0 1px 4px rgba(0,0,0,0.08)",
    };
  }
  if (size === "large") {
    return {
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 0.15,
      shadowRadius: 20,
      elevation: 8,
    };
  }
  return {
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 4,
    elevation: 2,
  };
};

/**
 * Tooltip shadow — web-only component so always uses boxShadow.
 */
export const tooltipShadow = {
  boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
};
